import { COLOR, FONT_WEIGHT, mq } from "@dmm-com/rocket-web-ui-library";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fadeIn } from "~/styles/animation";
import { HIDE_SCROLL_BAR } from "~/styles/hide-scroll-bar";

/**
 * keyframes output got interpolated into plain string, please wrap it with `css`
 * - 上記、エラーがConsoleタブに出力させるため`css関数`でラッピングしている
 */
const COMMON_ARROW_BTN_STYLE = css`
  position: absolute;
  z-index: 1;
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  animation: ${fadeIn} 0.25s ease-in;
  transition: opacity 0.25s ease-in;

  width: 32px;
  height: 56px;

  ${mq.sp} {
    width: 24px;
    height: 48px;
  }
`;

export const DivPositionRelative = styled.div`
  position: relative;
`;

export const DivScrollAreaRoot = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow-x: auto;
  width: 100%;
  margin-bottom: 16px;

  ${HIDE_SCROLL_BAR}
`;

export const DivFlexContainer = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const ButtonLeftArrow = styled.button`
  ${COMMON_ARROW_BTN_STYLE}

  left: 0;

  background: linear-gradient(to left, transparent 20%, ${COLOR.GRAY100.code});
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ButtonRightArrow = styled.button`
  ${COMMON_ARROW_BTN_STYLE}

  right: 0;

  background: linear-gradient(to right, transparent 20%, ${COLOR.GRAY100.code});
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const ButtonItem = styled.button<{ isActive: boolean }>`
  display: block;
  width: 72px;
  height: 56px;
  text-align: center;
  border-top: 1px solid ${COLOR.GRAY200.code};
  border-bottom: 1px solid ${COLOR.GRAY200.code};
  border-right: 1px solid ${COLOR.GRAY200.code};
  font-size: 14px;
  background-color: ${({ isActive }) => (isActive ? COLOR.GRAY200.code : COLOR.GRAY100.code)};
  font-weight: ${({ isActive }) => (isActive ? FONT_WEIGHT.BOLD : FONT_WEIGHT.NORMAL)};

  ${mq.sp} {
    width: 56px;
    height: 48px;
    font-size: 12px;
  }

  :first-of-type {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  :last-of-type {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

export const SpanDayOfWeek = styled.span`
  display: block;
  font-size: 10px;

  ${mq.sp} {
    font-size: 8px;
  }
`;

export const SpanDate = styled.span`
  display: block;
  font-size: 12px;

  ${mq.sp} {
    font-size: 10px;
  }
`;
